import httpClient from "./httpClient"; // Adjust path if needed

const AnnouncementService = {
  async findAll(page, pageSize) {
    return await httpClient.get("/announcement", {
      params: { page, pageSize }
    });
  },

  async findById(announcementId) {
    return await httpClient.get(`/announcement/${announcementId}`);
  },

  async create(entity) {
    return await httpClient.post("/announcement", entity);
  }
};

export default AnnouncementService;
